import { render, staticRenderFns } from "./CarouselDot.vue?vue&type=template&id=dd6ed2e4&scoped=true"
import script from "./CarouselDot.vue?vue&type=script&lang=js"
export * from "./CarouselDot.vue?vue&type=script&lang=js"
import style0 from "./CarouselDot.vue?vue&type=style&index=0&id=dd6ed2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6ed2e4",
  null
  
)

export default component.exports